import { render } from "./VideoJS.vue?vue&type=template&id=f8119544"
import script from "./VideoJS.vue?vue&type=script&lang=js"
export * from "./VideoJS.vue?vue&type=script&lang=js"

import "./VideoJS.vue?vue&type=style&index=0&id=f8119544&scope=true&lang=css"

import exportComponent from "/home/olt/CloudRaiseWebSite/vue/client/node_modules/@vue/cli-service/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__